import moment from 'moment';

function BulkRefundFileViewModel(data) {
    this.selectedBulkUploadFileTableData = this.createTableData(data);
    this.pagination = this.createPaginationData(data);
}

BulkRefundFileViewModel.prototype = Object.assign(
    BulkRefundFileViewModel.prototype,
    {
        createTableData(data) {
            return (
                data &&
                data.response &&
                data.response.refundReqResLst &&
                data.response.refundReqResLst.map(row => this.createRow(row))
            );
        },
        createPaginationData(data) {
            if (data.response && data.request) {
                return {
                    hasNextPage: false,
                    hasPreviousPage: false,
                    pageNumber: 1,
                    pageSize: 10,
                    sortingCriteria: '',
                    totalNumberOfPages: 0,
                    totalNumberOfRecords:
                        data.response.pageNo * data.request.pageSize,
                };
            }
            return {};
        },
        createRow(row) {
            const {
                merchantRefundTxnId,
                statusCode,
                refundAmount,
                statusMessage,
            } = row;
            return {
                merchantRefundTxnId,
                status: this.formatStatus(statusCode) || '-',
                refundAmount,
                statusMessage,
            };
        },
        formatData(date) {
            return moment(date).format('DD/MM/YYYY');
        },
        formatStatus(status) {
            if (status === 'SUCCESS') {
                return 'Success';
            }
            if (status === 'FAILED') {
                return 'Failed';
            }
            if (status === 'PENDING') {
                return 'Pending';
            }
            if (status === 'INITIATED') {
                return 'Pending';
            }
            return '-';
        },
    }
);

export default BulkRefundFileViewModel;
